import angular from 'angular';
import { runnerSetupDeleteWarningsBridge } from './RunnerSetupDeleteWarningsBridge';

/**
 * @ngdoc directive
 * @name runnerSetupDeleteWarnings
 * @module flowingly.runner.setup
 * @description  This component is used to dipslay warnings related to deleteing an entity
 * @usage
 * ```
     
 * ``` 
 * ### Notes
 *
 * 
 * ### Properties
 * #### Inputs
 * * warnings: the lsit of warnings (JSON[])
 */
(function () {
  'use strict';

  angular
    .module('flowingly.runner.setup')
    .component('runnerSetupDeleteWarnings', runnerSetupDeleteWarningsBridge);
})();
